import React, { useState, useEffect } from 'react';
import { Button, Form, Image, Modal } from 'react-bootstrap';
import StarRating from 'react-star-ratings';
import { useSearchParams } from 'react-router-dom';
// eslint-disable-next-line import/no-duplicates
import { format } from 'date-fns';
import { Formik } from 'formik';
import { useToast } from '../hooks/toast';

import ArrowRightCircle from '../assets/icon/arrowRightCircle.svg';
import StatusFeedbackBomIcon from '../assets/icon/statusFeedbackBom.svg';
import StatusFeedbackMedioIcon from '../assets/icon/statusFeedbackMedio.svg';
import StatusFeedbackRuimIcon from '../assets/icon/statusFeedbackRuim.svg';
import ButtonDotsIcon from '../assets/icon/buttonDots.svg';
import iconSearch from '../assets/icon/search.svg';

import api from '../services/apiClient';
import IFeedbackData from '../interfaces/IFeedbackData';
import { formatLocalDateTime } from '../utils/dateTime';

interface Props {
  setDataFeedback: React.Dispatch<React.SetStateAction<IFeedbackData>>;
  setShowDetail: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Users {
  seqUsuario: number;
  nome: string;
}

const FeedbackResume: React.FC<any> = ({
  setDataFeedback,
  setShowDetail,
}: Props) => {
  const { addToast } = useToast();
  const [dataLoad, setDataLoad] = useState<IFeedbackData[]>([]);
  const [dataTexto, setDataTexto] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [usuario, setUsuario] = useState<Users[]>([]);

  interface FormField {
    periodoInicial: string;
    periodoFinal: string;
    seqUsuario: number;
    statusAtendimento: number;
  }

  const statusAtendimento = [
    {
      id: 0,
      name: 'Todos',
    },
    {
      id: 1,
      name: 'Bom',
    },
    {
      id: 2,
      name: 'Médio',
    },
    {
      id: 3,
      name: 'Ruim',
    },
  ];

  const dataFormatada = format(new Date(), 'yyyy-MM-dd');

  const initialValues: FormField = {
    periodoInicial: dataFormatada,
    periodoFinal: dataFormatada,
    seqUsuario: 0,
    statusAtendimento: 0,
  };

  const loadFeedbeekFilter = (filtroAvaliacao: FormField): void => {
    const token = localStorage.getItem('@LiveChat:token');

    const filtro = {
      ...filtroAvaliacao,
      statusAtendimento: Number(filtroAvaliacao.statusAtendimento),
    };
    api
      .post('/AvaliacaoAtendimento/AvaliacaoFiltro', filtro, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { success } = response.data;

        if (success) {
          setDataLoad(response.data.data);
        } else {
          addToast({
            type: 'error',
            title: 'Erro',
            description: 'Não foi possível carregar os dados',
          });
          setDataLoad([]);
        }
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Não foi possível carregar os dados',
        });
      });
  };

  const filtroId =
    searchParams.get('id') === null ? 0 : Number(searchParams.get('id'));

  useEffect(() => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get('/api/user', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data: users } = response.data;
        setUsuario(users);
      });
  }, []);

  useEffect(() => {
    loadFeedbeekFilter(initialValues);
  }, [filtroId]);

  const showIconFeedback = (avaliacao: number): string => {
    if (avaliacao <= 2) return StatusFeedbackRuimIcon;
    if (avaliacao <= 3) return StatusFeedbackMedioIcon;
    return StatusFeedbackBomIcon;
  };

  return (
    <div className="d-flex flex-column" style={{ flex: 1, overflow: 'hidden' }}>
      <Modal
        centered
        show={dataTexto.length > 0}
        onHide={() => setDataTexto('')}
      >
        <Modal.Body>{dataTexto}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setDataTexto('')}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="ms-2 mb-2">
        <Formik
          initialValues={initialValues}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            console.log(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
            resetForm,
          }) => (
            <Form>
              <div className="d-flex justify-content-center align-items-end">
                <Form.Group className="p-0">
                  <Form.Label htmlFor="inputPeriodoInicial" className="mb-0">
                    Data Inicial
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="periodoInicial"
                    max="2999-12-31"
                    className={
                      (touched.periodoInicial || touched.periodoFinal) &&
                      errors.periodoFinal
                        ? 'is-invalid'
                        : 'p-0 inputBox'
                    }
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    value={values.periodoInicial}
                  />
                  {touched.periodoFinal && errors.periodoFinal ? (
                    <div className="invalid-feedback">
                      {errors.periodoFinal}
                    </div>
                  ) : null}
                </Form.Group>

                <Form.Group className="p-0 ms-2">
                  <Form.Label htmlFor="inputPeriodoFinal" className="mb-0">
                    Data Final
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="periodoFinal"
                    max="2999-12-31"
                    className="p-0 inputBox"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    value={values.periodoFinal}
                  />
                </Form.Group>

                <Form.Group className="ms-2 w-50">
                  <Form.Label className="mb-0">Atendente</Form.Label>
                  <Form.Select
                    size="sm"
                    name="seqUsuario"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    value={values.seqUsuario}
                    className="inputBox"
                  >
                    <option value={0}>Todos</option>
                    {usuario.map((user) => (
                      <option key={user.seqUsuario} value={user.seqUsuario}>
                        {user.nome}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="ms-2 w-50">
                  <Form.Label className="mb-0">Status Atendimento</Form.Label>
                  <Form.Select
                    size="sm"
                    name="statusAtendimento"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    className="inputBox"
                  >
                    {statusAtendimento.map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="ms-2 me-2 d-flex">
                  <Button
                    className=""
                    style={{ height: '2.75rem' }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onClick={() => {
                      loadFeedbeekFilter(values);
                    }}
                  >
                    <Image
                      src={iconSearch}
                      alt="search"
                      style={{ height: '1.75rem', width: '1.75rem' }}
                    />
                  </Button>
                </Form.Group>
              </div>
            </Form>
          )}
        </Formik>
      </section>

      <div
        className="table-responsive"
        style={{
          borderRadius: '0.68rem',
          flex: '1',
          overflow: 'auto',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <table className="table table-nowrap mb-0 overflow-auto">
          <thead
            className=" fw-light text-dark position-sticky top-0"
            style={{
              backgroundColor: '#D9D9D9',
              borderRadius: '0.68rem!important',
              fontSize: '1.25rem',
              zIndex: '1',
            }}
          >
            <tr
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
              }}
            >
              <th className="col">Status</th>
              <th className="col-2">Nome</th>
              <th className="col-1">Dt. Atend.</th>
              <th className="col-2">Atendente</th>
              <th className="col-2">Avaliação Geral</th>
              <th className="col-3">Comentário</th>
              <th className="col"> </th>
            </tr>
          </thead>
          <tbody>
            {dataLoad.map((msg) => (
              <tr
                key={msg.seqAtendimento}
                style={{
                  backgroundColor: '#F4F4F4',
                  verticalAlign: 'middle',
                  fontSize: '1.25rem',
                  height: 'auto',
                }}
              >
                <td>
                  <Image
                    src={showIconFeedback(msg.avaliacao)}
                    style={{ height: '2.81rem', width: '2.81rem' }}
                    alt="Status atendimento"
                  />
                </td>
                <td>
                  {msg.nomeCliente?.length > 40
                    ? msg.nomeCliente.substring(0, 40)
                    : msg.nomeCliente}{' '}
                  {msg.nomeCliente.length > 40 && (
                    <Image
                      style={{ cursor: 'pointer' }}
                      className="ms-1"
                      src={ButtonDotsIcon}
                      alt="Nome do Cliente"
                      onClick={() => setDataTexto(msg.nomeCliente)}
                    />
                  )}
                </td>
                <td>
                  {formatLocalDateTime(msg.dataAtendimentoCriado, 'dd/MM/yyyy')}
                </td>
                <td>{msg.atendente}</td>
                <td>
                  <div className="d-flex">
                    <StarRating
                      name="react-star-rating"
                      numberOfStars={5}
                      rating={msg.avaliacao}
                      starRatedColor="#ffc107"
                      starEmptyColor="#ced4da"
                      starHoverColor="#ffc107"
                      starDimension="1.4rem"
                    />
                    <span className="ms-2">{`(${msg.avaliacao},0)`}</span>
                  </div>
                </td>
                <td>
                  <div>
                    {msg.comentario?.length > 50
                      ? `${msg.comentario.substring(0, 50)}`
                      : msg.comentario}
                    {msg.comentario?.length > 50 && (
                      <Image
                        style={{ cursor: 'pointer' }}
                        className="ms-1"
                        src={ButtonDotsIcon}
                        alt="Comentário"
                        onClick={() => setDataTexto(msg.comentario)}
                      />
                    )}
                  </div>
                </td>
                <td>
                  <Button
                    variant="primary"
                    type="button"
                    className=""
                    style={{
                      fontSize: '1.25rem',
                      fontWeight: '600',
                      height: '2.6rem',
                      margin: '0',
                    }}
                    onClick={() => {
                      setDataFeedback(msg);
                      setShowDetail(true);
                      searchParams.set('principal', 'false');
                      setSearchParams(searchParams);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <Image
                        src={ArrowRightCircle}
                        alt="Seta direita"
                        style={{ height: '1.37rem', width: '1.37rem' }}
                      />
                      <span className="ms-2" style={{ fontSize: '1rem' }}>
                        ver mais
                      </span>
                    </div>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeedbackResume;
